// IMAGE SLIDER
const imageSliderSections = document.querySelectorAll('.o-sec.image-slider');
if(imageSliderSections.length > 0) {
  imageSliderSections.forEach(function(sliderSection) {
    const slider = sliderSection.querySelector('.c-slider');
    const sliderNextArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.next');
    const sliderPrevArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.prev');
    
    const imageSlider = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: sliderNextArrow,
        prevEl: sliderPrevArrow,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
        992: {
          slidesPerView: 2,
        }
      }
    });

    // PAGINATION BULLET CHANGE
    imageSlider.on('slideChange', function(swiper) {
      const currentSlideIndex = swiper.realIndex;        
      const sliderBullets = sliderSection.querySelectorAll('.c-slider-bullet');
      sliderBullets.forEach(function(bullet, index) {
        if( index === currentSlideIndex ) {
          bullet.classList.add('active');
        } else {
          bullet.classList.remove('active');
        }
      });
    });
  });
}